import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { Content } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Create Course text content
 * @param course_id
 * @param version
 * @param content
 */
const createCourseTextContent = (
  course_id: string,
  version: number,
  content: {}
): Promise<Content> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.COURSE + course_id + '/' + version + '/text'
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    const data = { lecture_content: content }

    AxiosClient.post(URL, data, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default createCourseTextContent
